module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/joystick.png?1ed32aadad1c5cc79f44c058cc84ca26";